import { CorrelationEndpointSource } from '../../../../../@types/projects/types';
import { Sample } from '../../../../../@types/samples/types';

const isFiniteNumber = (value: number | null | undefined): value is number =>
  typeof value === 'number' && Number.isFinite(value);

export interface WaterOilResolvedValues {
  swi: number | null;
  sor: number | null;
  no: number | null;
  nw: number | null;
  krwEndpoint: number | null;
  kroEndpoint: number;
}

export const resolveWaterOilValues = (
  sample: Sample | null | undefined,
  source: CorrelationEndpointSource
): WaterOilResolvedValues => {
  const inputValues = sample?.input_sample_values;
  const inputCurves = sample?.input_sample_curves?.water_oil;
  const krelValues = sample?.k_rel_values?.water_oil;
  const isRefinement = source === 'refinement';

  return {
    swi: inputValues?.swi ?? inputCurves?.sw_krel?.[0] ?? null,
    sor: isRefinement
      ? krelValues?.true_sor_w ?? krelValues?.sor_w ?? null
      : krelValues?.sor_w ?? null,
    no: isRefinement
      ? krelValues?.true_no_w ?? krelValues?.no_w ?? null
      : krelValues?.no_w ?? null,
    nw: isRefinement
      ? krelValues?.true_nw ?? krelValues?.nw ?? null
      : krelValues?.nw ?? null,
    krwEndpoint: isRefinement
      ? krelValues?.true_krw ?? krelValues?.krw_exponent ?? inputValues?.krw_absolute ?? null
      : krelValues?.krw_exponent ?? inputValues?.krw_absolute ?? null,
    kroEndpoint: isRefinement ? krelValues?.true_kro_w ?? 1 : 1
  };
};

export const hasCompleteWaterOilValues = (values: WaterOilResolvedValues) =>
  isFiniteNumber(values.swi) &&
  isFiniteNumber(values.sor) &&
  isFiniteNumber(values.no) &&
  isFiniteNumber(values.nw) &&
  isFiniteNumber(values.krwEndpoint) &&
  isFiniteNumber(values.kroEndpoint);
